import i18n from "i18n";
const SidebarEventDefinitionDetails = (id) => ({
  id: "event-definition-details",
  title: i18n.t("sidebar.details_title", { ns: "event_definitions" }),
  componentKey: "replay-search-sidebar",
  props: { alertId: void 0, definitionId: id }
});
export default SidebarEventDefinitionDetails;
